import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { relationshipsReportQueryOptions } from '~bank-reports/service/relationshipsReportQueryOptions'

import { relationshipsReportSchema } from './schema'

export const relationshipsReportRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: 'relationships',
    component: lazyRouteComponent(() => import('./RelationshipsReport')),
    validateSearch: (search: Record<string, unknown>) => relationshipsReportSchema.parse(search),
    loader: ({ cause, deps, context }) => {
      if (cause === 'stay') {
        return null
      }
      return (context as BPRoutingContext).queryClient.ensureQueryData(relationshipsReportQueryOptions(deps))
    }
  })
